import { addFilter } from '@wordpress/hooks'
import { useSelect, dispatch } from '@wordpress/data'
import { PanelRow, TextControl, ToggleControl } from '@wordpress/components'
import { __ } from '@wordpress/i18n'

/**
 * Adding Instamojo Content
 */
addFilter( 'wp_travel_payment_gateway_fields_instamojo_checkout', 'wp-travel', (content) => {
    return [ ...content, <InstaMojoContent /> ]
});

const InstaMojoContent = () => {

    /**
     * Get Store Settings.
     */
    const { updateSettings } = dispatch('WPTravel/Admin');

    const allData = useSelect( (select) => {
        return select('WPTravel/Admin').getAllStore()
    }, [] );

    const {
        payment_option_instamojo_checkout,
        wp_travel_instamojo_checkout,
        wt_test_mode
    } = allData

    const updateInstaMojoData = (storeName, storeKey, value) => { // storeName[storeKey] = value
        updateSettings({ ...allData, [storeName]: { ...allData[storeName], [storeKey]: value } })
    }

    const clientIdDesc = _wp_travel.setting_strings.payment.private_auth_token_note + __('<a href="https://instamojo.com/integrations" target="__blank">here</a>', 'wp-travel-instamojo-checkout');

    return (
        <>
            {
                wt_test_mode === 'yes' ?
                <strong><p className="howTo" style={{color: '#ffffff', textAlign: 'center', backgroundColor: 'darkseagreen'}} >{ __( 'Test Mode Active', 'wp-travel-instamojo-checkout' ) }</p></strong>
                : <strong><p className="howTo" style={{color: '#ffffff', textAlign: 'center', backgroundColor: 'darkseagreen'}} >{ __( 'Live Mode Active', 'wp-travel-instamojo-checkout' ) }</p></strong>
            }
            <PanelRow>
                <label>{ _wp_travel.setting_strings.payment.enable_instamojo_checkout }</label>
                <div className="wp-travel-field-value">
                    <ToggleControl
                        checked={ payment_option_instamojo_checkout == 'yes' }
                        onChange={ () => {
                            updateSettings({
                                ...allData,
                                payment_option_instamojo_checkout: 'yes' == payment_option_instamojo_checkout ? 'no': 'yes'
                            })
                        } }
                    />
                    <p className="description">{_wp_travel.setting_strings.payment.enable_instamojo_checkout_note}</p>
                </div>
            </PanelRow>

            {
                payment_option_instamojo_checkout === 'yes' &&
                <>
                    <PanelRow>
                        <label>{ _wp_travel.setting_strings.payment.private_api_key }</label>
                            <div className="wp-travel-field-value">
                                <TextControl
                                    value={ 'undefined' != typeof wp_travel_instamojo_checkout ? wp_travel_instamojo_checkout.api_key : '' }
                                    onChange={
                                        (value) => {
                                            updateInstaMojoData( 'wp_travel_instamojo_checkout', 'api_key', value );
                                        }
                                    }
                                />
                                <p className="description">{__( 'e.g. test_da0025f5d69d016f...', 'wp-travel-instamojo-checkout' )}</p>
                            </div>
                    </PanelRow>

                    <PanelRow>
                        <label>{ _wp_travel.setting_strings.payment.private_auth_token }</label>
                            <div className="wp-travel-field-value">
                                <TextControl
                                    value={ 'undefined' != typeof wp_travel_instamojo_checkout ? wp_travel_instamojo_checkout.auth_token : '' }
                                    onChange={
                                        (value) => {
                                            updateInstaMojoData( 'wp_travel_instamojo_checkout', 'auth_token', value );
                                        }
                                    }
                                />
                                <p className="description">{__( 'e.g. test_da0025f5d69d016f...', 'wp-travel-instamojo-checkout' )}</p>
                                <p className="description" dangerouslySetInnerHTML={{ __html: clientIdDesc }}></p>
                            </div>
                    </PanelRow>

                    <PanelRow>
                        <p className="description">{ _wp_travel.setting_strings.payment.instamojo_checkout_note }</p>
                    </PanelRow>

                </>
            }
        </>
    )
}